import styled from 'styled-components';

export const Wrapper = styled.div``;

export const ErrorTextWrapper = styled.div`
    text-align: right;
`;
